import { makeEnvironmentProviders } from '@angular/core';
import { ChatStore, PromptGeneratorService } from '@coin/chat-bot-data-access';

export function provideChatBot() {
  return makeEnvironmentProviders([ChatStore, PromptGeneratorService]);
}
